import * as React from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useContext, useEffect, useState } from 'react';
import { Alert, DialogTitle, Grid } from '@mui/material';

import { useRegister } from '../../hooks/users';
import { UserContext } from '../../contexts/userContext';
import { IndicatorButton } from '../IndicatorButton';


export interface NuevoUsuarioProps {
  open: boolean;
  onClose: () => void;
}

export interface NewUser {
  pass1?: string;
  pass2?: string;
  username?: string;
}

export default function NuevoUsuario(props:NuevoUsuarioProps) {
  const { open, onClose } = props;
  const [ mutableUsuario, setMutableUsuario ] = useState<NewUser | undefined>();
  const [errorMessage, setErrorMessage] = useState('');
  const { setUser } = useContext(UserContext);


  const registrarUsuario = useRegister(mutableUsuario);

  const handleSubmit = () => {
    registrarUsuario.refetch();
  };

  useEffect(() => {
    if (registrarUsuario.data?.register) {
      setErrorMessage('');
      setUser(registrarUsuario.data);
      onClose();
    }
    if (registrarUsuario.data?.message === 'Usuario ya registrado') {

      setErrorMessage('El usuario ya está registrado');
    }
    if (registrarUsuario.data?.message === 'Usuario no encontrado') {
      setErrorMessage('El nombre de usuario no se encuentra, contactese con un administrador para que lo agregue a la lista');
    }
  }, [registrarUsuario.data]);

  return (
    <div>
      <Dialog open={open} onClose={onClose} closeAfterTransition >
        <DialogTitle>Editar informacion del usuario</DialogTitle>
        <DialogContent>
          {errorMessage && <Alert severity="error" >{errorMessage}</Alert>}
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                id="email"
                label="Nombre de usuario"
                type="text"
                fullWidth
                variant="standard"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setMutableUsuario((prev) => ({ ...prev, username: (event.target as HTMLInputElement).value as string }));
                }}
                value={mutableUsuario?.username ?? ''}
                required
                error={!mutableUsuario?.username}
                helperText={!mutableUsuario?.username ? 'El nombre de usuario no puede quedar vacio' : ''}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                margin="dense"
                id="password"
                label="Contraseña"
                type="password"
                fullWidth
                variant="standard"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setMutableUsuario((prev) => ({ ...prev, pass1: (event.target as HTMLInputElement).value as string }));
                }}
                value={mutableUsuario?.pass1 ?? ''}
                required
                error={!!mutableUsuario?.pass1?.length && mutableUsuario?.pass1?.length < 6}
                helperText={!!mutableUsuario?.pass1?.length && mutableUsuario?.pass1?.length < 6
                  ? 'La contraseña no puede tener menos de 6 caracteres' : ''}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                margin="dense"
                id="password"
                label="Repita contraseña"
                type="password"
                fullWidth
                variant="standard"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setMutableUsuario((prev) => ({ ...prev, pass2: (event.target as HTMLInputElement).value as string }));
                }}
                value={mutableUsuario?.pass2 ?? ''}
                required
                error={mutableUsuario?.pass2 !== mutableUsuario?.pass1}
                helperText={mutableUsuario?.pass2 !== mutableUsuario?.pass1 ? 'Las contraseñas no coinciden' : ''}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <IndicatorButton
            label='Volver'
            loading={registrarUsuario.isLoading}
            onClick={() => {
              onClose();
              setMutableUsuario(undefined);
            }}
          />
          <IndicatorButton
            label='Guardar Cambios'
            disabled={
              !mutableUsuario?.pass1
              || !mutableUsuario.pass2
              || !mutableUsuario.username
            }
            onClick={handleSubmit}
            loading={registrarUsuario.isLoading}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}
